import { render, staticRenderFns } from "./archive.vue?vue&type=template&id=51c5803f&scoped=true"
import script from "./archive.vue?vue&type=script&lang=js"
export * from "./archive.vue?vue&type=script&lang=js"
import style0 from "./archive.vue?vue&type=style&index=0&id=51c5803f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51c5803f",
  null
  
)

export default component.exports